import { FieldUsageId } from '@sonar-software/sonar-core';
import React from 'react';
import { Tag } from 'antd';
const fieldUsageColors = {
    [FieldUsageId.Active]: 'green',
    [FieldUsageId.DeprecateCandidate]: 'volcano'
};
export const FieldUsageTag = ({ fieldUsageId = FieldUsageId.None }) => {
    const label = FieldUsageId[fieldUsageId];
    const color = fieldUsageColors[fieldUsageId];
    return fieldUsageId === FieldUsageId.None ? label : React.createElement(Tag, { color: color }, label);
};
